query allEvents(
  $first: Int,
  $offset: Int,
  $orderBy: [EventsOrderBy!],
  $condition: EventCondition,
  $filter: EventFilter,
) {
  events: allEvents(
    first: $first,
    offset: $offset,
    orderBy: $orderBy,
    condition: $condition,
    filter: $filter
  ) {
    nodes {
      eventId
      eventName
      eventIsCoveredsByEventId {
        nodes {
          available
          eventId
          liveDataLatencyLevel
        }
      }
      matchState
      sportId
      startsAt
      isUsaView
      source,
      eventType
      limbo
      sport {
        sportId
        sportLabel
        sportName
      }
      region {
        regionId
        regionName
      }
      season {
        seasonId
        seasonName
      }
      competition {
        competitionId
        competitionName
        competitionFeedConfiguration: competitionFeedConfigurationsByCompetitionId {
          nodes {
            feed
            marketCategories
            priority
          }
        }
      }
      primaryFeedOverrides: eventPrimaryFeedOverridesByEventId {
        nodes {
          primaryFeeds
        }
      }
      competitors
      eventHasExternalPricesByEventId {
        nodes {
          hasExternalPrices
        }
      }
      eventHasInternalPricesByEventId {
        nodes {
          hasInternalPrices
        }
      }
      eventIsMappedsByEventId {
        nodes {
          isMapped
        }
      }
      mappings: eventMappingsByIntId(
        filter: {
          mappingType: {
            equalTo: "EXACT_MATCH",
          },
        }
      ) {
        nodes {
          feed
        }
      }
      bookedEvents: bookedEventsByEventId {
        nodes {
          bookedAt
          bookedBy
          pricingMode
          isOfferedLive
          isOfferedPreMatch
        }
      }
      bookedPlayerProps: playerPropsBookedEventsByEventId {
        nodes {
          bookedAt
          bookedBy
          isOfferedLive
          isOfferedPreMatch
        }
      }
      bookedSameGameParlays: sgpBookedEventsByEventId {
        nodes {
          bookedAt
          bookedBy
          isOfferedLive
          isOfferedPreMatch
        }
      }
      bookedMicroMarkets: microBookedEventsByEventId {
        nodes {
          bookedAt
          bookedBy
          isOfferedLive
          isOfferedPreMatch
        }
      }
      operatorEventSuspensionsByEventId {
        nodes {
          operatorId
        }
      }
      appliedTemplates: eventAppliedTemplatesByEventId(filter: {appliedSportTemplateExists: true}) {
        nodes {
          appliedSportTemplateId
        }
      }
      eventHighlightsByEventId {
        nodes {
          nodeId
        }
      }
      eventReadiness: eventReadinessByEventId {
        isApproved
      }
      operatorEventUndisplaysByEventId {
        nodes {
          eventId
        }
      }
      manuallyCreated
      manuallyUpdated
      pricingProbabilitiesByEventId {
        nodes {
          pricingExceptionDescription
          pricingException
        }
      }
      eventParamsByEventId {
        nodes {
          gameParamsSource
          isLimitedOffer
        }
      }
    }
    totalCount
  }
}
